'use client'

import type { ReactNode } from 'react'
import { useT } from '../../contexts/LocaleContext'

type SocialItem = {
  key: 'instagram' | 'telegram' | 'twitter' | 'youtube' | 'tiktok'
  href: string
  telegram?: boolean
  icon: ReactNode
}

const LINKS: SocialItem[] = [
  {
    key: 'instagram',
    href: 'https://www.instagram.com/sisil_org',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M7.5 2h9A5.5 5.5 0 0 1 22 7.5v9A5.5 5.5 0 0 1 16.5 22h-9A5.5 5.5 0 0 1 2 16.5v-9A5.5 5.5 0 0 1 7.5 2Zm0 2A3.5 3.5 0 0 0 4 7.5v9A3.5 3.5 0 0 0 7.5 20h9a3.5 3.5 0 0 0 3.5-3.5v-9A3.5 3.5 0 0 0 16.5 4h-9Zm9.75 1.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
        />
      </svg>
    ),
  },
  {
    key: 'telegram',
    href: 'https://t.me/sisil_org',
    telegram: true,
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M21.8 4.3c.3-.1.6.2.5.5l-3.1 14.6c-.1.4-.5.6-.9.4l-5-2.4-2.5 2.4c-.3.3-.8.1-.9-.3l-.5-4.1 9.1-8.2c.2-.2 0-.5-.2-.3L7.3 13.8 3.4 12.5c-.5-.2-.5-.9.1-1.1L21.8 4.3Z"
        />
      </svg>
    ),
  },
  {
    key: 'twitter',
    href: 'https://twitter.com/sisil_org',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M18.9 2H22l-6.8 7.8L23 22h-6.3l-4.9-6.4L6.2 22H3l7.3-8.3L1 2h6.5l4.4 5.8L18.9 2Zm-1.1 18h1.8L6.3 3.9H4.4L17.8 20Z"
        />
      </svg>
    ),
  },
  {
    key: 'youtube',
    href: 'https://www.youtube.com/@sisil_org',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M23.5 7.2a3 3 0 0 0-2.1-2.1C19.5 4.5 12 4.5 12 4.5s-7.5 0-9.4.6A3 3 0 0 0 .5 7.2 31.6 31.6 0 0 0 0 12a31.6 31.6 0 0 0 .5 4.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1A31.6 31.6 0 0 0 24 12a31.6 31.6 0 0 0-.5-4.8ZM9.8 15.5v-7L16 12l-6.2 3.5Z"
        />
      </svg>
    ),
  },
  {
    key: 'tiktok',
    href: 'https://www.tiktok.com/@sisil_org',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M16.5 2c.4 2.4 1.8 4.2 4.3 4.7v3.1c-1.5-.1-2.9-.6-4.1-1.5v6.5a6.7 6.7 0 1 1-6.7-6.7c.3 0 .7 0 1 .1v3.3a3.5 3.5 0 1 0 2.5 3.3V2h3Z"
        />
      </svg>
    ),
  },
]

function openExternal(href: string, telegram?: boolean) {
  const tg = window.Telegram?.WebApp

  if (telegram && tg?.openTelegramLink) {
    tg.openTelegramLink(href)
    return
  }
  if (tg?.openLink) {
    tg.openLink(href, { try_instant_view: false })
    return
  }
  window.open(href, '_blank', 'noopener,noreferrer')
}

export default function SocialLinks() {
  const t = useT()
  return (
    <section className="lucky-social" aria-label={t('home.social.sectionAria')}>
      <div className="lucky-home__section-head">
        <h3>{t('home.social.title')}</h3>
      </div>
      <div className="lucky-social__row">
        {LINKS.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`lucky-social__btn lucky-social__btn--${item.key}`}
            title={t(`home.social.${item.key}`)}
            aria-label={t(`home.social.${item.key}`)}
            onClick={() => openExternal(item.href, item.telegram)}
          >
            {item.icon}
          </button>
        ))}
      </div>
    </section>
  )
}
